"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectDefaultTab = void 0;
const reselect_1 = require("reselect");
const selectContent_1 = require("./selectContent");
exports.selectDefaultTab = (0, reselect_1.createSelector)(selectContent_1.selectContent, content => content === null || content === void 0 ? void 0 : content.defaultTabType);
